import * as React from "react";
import * as _ from "lodash"

const Input: React.FC<{ isValid?: boolean } & React.HTMLProps<HTMLInputElement>> = (props) => (
    <input
        {..._.omit(props, "isValid")}
        type="text"
        className={`form-control ${props.isValid === false ? "is-invalid" : ""} ${props.className || ""}`}
        pattern="[0-9]*"
    />
)

interface IProps extends React.HTMLProps<HTMLInputElement> {
    isValid?: boolean
}

interface IState {
    day: string
    month: string
    year: string
}

export class DateInput extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        let day = "";
        let month = "";
        let year = "";

        if (props.value) {
            [year, month, day] = (props.value as string).split("-");
        }

        this.state = {
            day,
            month,
            year,
        };
    }

    public componentDidUpdate(prevProps: IProps) {
        if (prevProps.value === this.props.value) {
            return;
        }
        const value = this.props.value as string;
        if (!value) {
            this.setState({day: "", month: "", year: ""});
        } else {
            const [year, month, day] = value.split("-");
            this.setState({day, month, year});
        }
    }

    public render() {
        return (
            <div className="customDate-container">
                <div>
                    <label className="font-weight-light" htmlFor={this.props.id}>Day<br/></label>
                    <Input
                        id={this.props.id}
                        className="customDate-day"
                        name="day"
                        value={this.state.day}
                        isValid={this.props.isValid}
                        onChange={this.handleChange}
                        placeholder="DD"
                        maxLength={2}
                    />
                </div>
                <div>
                    <label className="font-weight-light" htmlFor={`${this.props.id}-month`}>Month<br/></label>
                    <Input
                        type="text"
                        id={`${this.props.id}-month`}
                        className="customDate-month"
                        name="month"
                        value={this.state.month}
                        isValid={this.props.isValid}
                        onChange={this.handleChange}
                        placeholder="MM"
                        maxLength={2}
                    />
                </div>
                <div>
                    <label className="font-weight-light" htmlFor={`${this.props.id}-year`}>Year<br/></label>
                    <Input
                        type="text"
                        id={`${this.props.id}-year`}
                        className="customDate-year"
                        name="year"
                        value={this.state.year}
                        isValid={this.props.isValid}
                        onChange={this.handleChange}
                        placeholder="YYYY"
                        maxLength={4}
                    />
                </div>
            </div>
        );
    }

    protected handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();

        const target = event.target as HTMLInputElement;

        if (!/^[0-9]*$/.test(target.value)) {
            return;
        }

        const newState = {
            [target.name]: target.value
        } as Pick<IState, keyof IState>;

        this.setState(
            newState,
            () => {
                if (this.props.onChange) {
                    const {day, month, year} = this.state;
                    const newValue = [year, month, day].join("-");
                    // @ts-ignore
                    event.target = {
                        ...event.target,
                        name: this.props.name,
                        value: newValue === "--" ? "" : newValue
                    } as EventTarget;
                    this.props.onChange(event);
                }
            }
        );

        const nextSibling = target.nextSibling as HTMLInputElement;
        if (nextSibling && target.value.length === target.maxLength) {
            nextSibling.focus();
            nextSibling.select();
        }
    };
}
